import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@shadcn-in-nx/ui/card";
import { CheckCircle, Clock, AlertCircle, Loader2 } from "lucide-react";

const ITEMS = [
    { key: "total", icon: Clock, color: "text-muted-foreground" },
    { key: "completed", icon: CheckCircle, color: "text-green-500" },
    { key: "inProgress", icon: Loader2, color: "text-blue-500" },
    { key: "failed", icon: AlertCircle, color: "text-red-500" },
    { key: "pending", icon: Clock, color: "text-yellow-500" },
];

export default function SummaryCards({ summary }) {
    const { t } = useTranslation();

    if (!summary) return null;

    return (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
            {ITEMS.map(({ key, icon: Icon, color }) => (
                <Card key={key}>
                    <CardContent className="flex items-center gap-3 p-4">
                        <Icon className={`h-5 w-5 ${color}`} />
                        <div>
                            <p className="text-2xl font-semibold">{summary[key] ?? 0}</p>
                            <p className="text-xs text-muted-foreground">{t(`adminDataMigration.${key}`)}</p>
                        </div>
                    </CardContent>
                </Card>
            ))}
        </div>
    );
}
